// Actions
export const COMPLETE_LOAD = 'customers/customers/COMPLETE_LOAD';
export const COMPLETE_DELETE = 'customers/customer/COMPLETE_DELETE';
